module.exports = __webpack_public_path__ + "static/img/ad12.8fe4a36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark40/ad12.png
// module id = KNg4
// module chunks = 12